// @flow

import type { Action } from './store.type';

export const GET_SYNONYMS_REQUEST = 'GET_SYNONYMS_REQUEST';
type GET_SYNONYMS_REQUEST_TYPE = 'GET_SYNONYMS_REQUEST';

export const GET_SYNONYMS_SUCCESS = 'GET_SYNONYMS_SUCCESS';
type GET_SYNONYMS_SUCCESS_TYPE = 'GET_SYNONYMS_SUCCESS';

export const GET_SYNONYMS_FAILURE = 'GET_SYNONYMS_FAILURE';
type GET_SYNONYMS_FAILURE_TYPE = 'GET_SYNONYMS_FAILURE';

type SynonymType = {
  searchTerm: string,
  synonyms: Array<string>,
  biDirection: boolean,
  allowSuggestion: boolean,
  tenantId: string,
  id: string
};

type GetSynonymSuccess = {
  skip: number,
  limit: number,
  data: Array<SynonymType>,
  total: number
};

type GetSynonymsFailure = {
  error: any
};

type GetSynonymsRequestAction = Action<GET_SYNONYMS_REQUEST_TYPE, null>;

type GetSynonymsSuccessAction = Action<GET_SYNONYMS_SUCCESS_TYPE, GetSynonymSuccess>;

type GetSynonymsFailureAction = Action<GET_SYNONYMS_FAILURE_TYPE, GetSynonymsFailure>;

// Bulk suggestions
export const BULK_SYNONYMS_REQUEST = 'BULK_SYNONYMS_REQUEST';
type BULK_SYNONYMS_REQUEST_TYPE = 'BULK_SYNONYMS_REQUEST';

export const BULK_SYNONYMS_SUCCESS = 'BULK_SYNONYMS_SUCCESS';
type BULK_SYNONYMS_SUCCESS_TYPE = 'BULK_SYNONYMS_SUCCESS';

export const BULK_SYNONYMS_FAILURE = 'BULK_SYNONYMS_FAILURE';
type BULK_SYNONYMS_FAILURE_TYPE = 'BULK_SYNONYMS_FAILURE';

type BulkSynonymsRequestAction = Action<BULK_SYNONYMS_REQUEST_TYPE, null>;

type BulkSynonymsSuccessAction = Action<BULK_SYNONYMS_SUCCESS_TYPE, BulkSynonymSuccess>;

type BulkSynonymsFailureAction = Action<BULK_SYNONYMS_FAILURE_TYPE, BulkSynonymsFailure>;

// Delete suggestions
export const DELETE_SYNONYMS_REQUEST = 'DELETE_SYNONYMS_REQUEST';
type DELETE_SYNONYMS_REQUEST_TYPE = 'DELETE_SYNONYMS_REQUEST';

export const DELETE_SYNONYMS_SUCCESS = 'DELETE_SYNONYMS_SUCCESS';
type DELETE_SYNONYMS_SUCCESS_TYPE = 'DELETE_SYNONYMS_SUCCESS';

export const DELETE_SYNONYMS_FAILURE = 'DELETE_SYNONYMS_FAILURE';
type DELETE_SYNONYMS_FAILURE_TYPE = 'DELETE_SYNONYMS_FAILURE';

type DeleteSynonymsRequestAction = Action<DELETE_SYNONYMS_REQUEST_TYPE, null>;

type DeleteSynonymsSuccessAction = Action<DELETE_SYNONYMS_SUCCESS_TYPE, DeleteSynonymsSuccess>;

type DeleteSynonymsFailureAction = Action<DELETE_SYNONYMS_FAILURE_TYPE, DeleteSynonymsFailure>;

// Update suggestion
export const UPDATE_SYNONYM_REQUEST = 'UPDATE_SYNONYM_REQUEST';
type UPDATE_SYNONYM_REQUEST_TYPE = 'UPDATE_SYNONYM_REQUEST';

export const UPDATE_SYNONYM_SUCCESS = 'UPDATE_SYNONYM_SUCCESS';
type UPDATE_SYNONYM_SUCCESS_TYPE = 'UPDATE_SYNONYM_SUCCESS';

export const UPDATE_SYNONYM_FAILURE = 'UPDATE_SYNONYM_FAILURE';
type UPDATE_SYNONYM_FAILURE_TYPE = 'UPDATE_SYNONYM_FAILURE';

type UpdateSynonymRequestAction = Action<UPDATE_SYNONYM_REQUEST_TYPE, null>;

type UpdateSynonymSuccessAction = Action<UPDATE_SYNONYM_SUCCESS_TYPE, UpdateSynonymSuccess>;

type UpdateSynonymFailureAction = Action<UPDATE_SYNONYM_FAILURE_TYPE, UpdateSynonymFailure>;

// Vefify csv file before importing
export const VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_REQUEST =
  'VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_REQUEST';
type VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_REQUEST_TYPE =
  'VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_REQUEST';

export const VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_SUCCESS =
  'VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_SUCCESS';
type VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_SUCCESS_TYPE =
  'VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_SUCCESS';

export const VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_FAILURE =
  'VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_FAILURE';
type VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_FAILURE_TYPE =
  'VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_FAILURE';

type VerifyContentBeforeImportSynonymsRequestAction = Action<
  VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_REQUEST_TYPE,
  null
>;

type VerifyContentBeforeImportSynonymsSuccessAction = Action<
  VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_SUCCESS_TYPE,
  VerifyContentBeforeImportSynonymsSuccess
>;

type VerifyContentBeforeImportSynonymsFailureAction = Action<
  VERIFY_CONTENT_BEFORE_IMPORT_SYNONYMS_FAILURE_TYPE,
  VerifyContentBeforeImportSynonymsFailure
>;

// Import file
export const IMPORT_FILE_SYNONYMS_REQUEST = 'IMPORT_FILE_SYNONYMS_REQUEST';
type IMPORT_FILE_SYNONYMS_REQUEST_TYPE = 'IMPORT_FILE_SYNONYMS_REQUEST';

export const IMPORT_FILE_SYNONYMS_SUCCESS = 'IMPORT_FILE_SYNONYMS_SUCCESS';
type IMPORT_FILE_SYNONYMS_SUCCESS_TYPE = 'IMPORT_FILE_SYNONYMS_SUCCESS';

export const IMPORT_FILE_SYNONYMS_FAILURE = 'IMPORT_FILE_SYNONYMS_FAILURE';
type IMPORT_FILE_SYNONYMS_FAILURE_TYPE = 'IMPORT_FILE_SYNONYMS_FAILURE';

type ImportFileSynonymsRequestAction = Action<IMPORT_FILE_SYNONYMS_REQUEST_TYPE, null>;

type ImportFileSynonymsSuccessAction = Action<
  IMPORT_FILE_SYNONYMS_SUCCESS_TYPE,
  ImportFileSynonymsSuccess
>;

type ImportFileSynonymsFailureAction = Action<
  IMPORT_FILE_SYNONYMS_FAILURE_TYPE,
  ImportFileSynonymsFailure
>;

// Export file
export const EXPORT_FILE_SYNONYMS_REQUEST = 'EXPORT_FILE_SYNONYMS_REQUEST';
type EXPORT_FILE_SYNONYMS_REQUEST_TYPE = 'EXPORT_FILE_SYNONYMS_REQUEST';

export const EXPORT_FILE_SYNONYMS_SUCCESS = 'EXPORT_FILE_SYNONYMS_SUCCESS';
type EXPORT_FILE_SYNONYMS_SUCCESS_TYPE = 'EXPORT_FILE_SYNONYMS_SUCCESS';

export const EXPORT_FILE_SYNONYMS_FAILURE = 'EXPORT_FILE_SYNONYMS_FAILURE';
type EXPORT_FILE_SYNONYMS_FAILURE_TYPE = 'EXPORT_FILE_SYNONYMS_FAILURE';

type ExportFileSynonymsRequestAction = Action<EXPORT_FILE_SYNONYMS_REQUEST_TYPE, null>;

type ExportFileSynonymsSuccessAction = Action<
  EXPORT_FILE_SYNONYMS_SUCCESS_TYPE,
  ExportFileSynonymsSuccess
>;

type ExportFileSynonymsFailureAction = Action<
  EXPORT_FILE_SYNONYMS_FAILURE_TYPE,
  ExportFileSynonymsFailure
>;

// Action and State
export type SynonymsAction =
  | GetSynonymsRequestAction
  | GetSynonymsSuccessAction
  | GetSynonymsFailureAction
  | BulkSynonymsRequestAction
  | BulkSynonymsSuccessAction
  | BulkSynonymsFailureAction
  | DeleteSynonymsRequestAction
  | DeleteSynonymsSuccessAction
  | DeleteSynonymsFailureAction
  | UpdateSynonymRequestAction
  | UpdateSynonymSuccessAction
  | UpdateSynonymFailureAction
  | VerifyContentBeforeImportSynonymsRequestAction
  | VerifyContentBeforeImportSynonymsSuccessAction
  | VerifyContentBeforeImportSynonymsFailureAction
  | ImportFileSynonymsRequestAction
  | ImportFileSynonymsSuccessAction
  | ImportFileSynonymsFailureAction
  | ExportFileSynonymsRequestAction
  | ExportFileSynonymsSuccessAction
  | ExportFileSynonymsFailureAction;

export type SynonymsState = {
  loading: boolean,
  success: boolean,
  successFlag: number,
  error: null,
  suggestions: Array<SynonymType> | [],
  total: number,
  saving: boolean,

  // Verify file content
  verifying: boolean,
  fileContentErrorCode: string,
  totalRecord: number,

  // Import file content
  importing: boolean,
  totalImportedRecords: number
};
